export default __webpack_public_path__ + "static/media/sidebar-icon-flights.523d625f.svg";